import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import FilterForm from "../components/FormComponents/FilterForm";
import { IoCloseOutline } from "react-icons/io5";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "#F5F5F5",
  boxShadow: 24,
  borderRadius: "0.75rem",
  maxHeight: "90vh",
  overflow: "auto"
};

const FilterModal = ({ open, onClose, filterProps }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div className="flex justify-between items-center px-4 mt-4 animate-fade-in-up">
          <Typography variant="h6" component="div">
            Filter
          </Typography>
          <IconButton onClick={onClose}>
            <IoCloseOutline />
          </IconButton>
        </div>
        <div className="animate-fade-in-up">
        <FilterForm {...filterProps} />
        </div>
      </Box>
    </Modal>
  );
};

export default FilterModal;
